// import React from 'react';

import React, { useState } from 'react'
import { Button, Typography, Box, Stack } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import BgBoxOld from '../../../components/BgBoxOld';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useEffect } from 'react';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import { isNotEmpty } from '../../../utils/format';
import { getNavData } from '../../../services/amtc-service';
import AttachFileUpload from '../../../components/AttachFileUpload';
import { createNewProdReqServ } from '../../../services/newprodreq-service';
import constants from '../../../utils/Constants';

function CreateNewProdReqPage() {
  const navigate = useNavigate();
  const { setLoadingScreen, ctxtUser } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const { isLoading, isError, error, data: userData } = useQuery([QueryKey.comUserProfile, ctxtUser.userId],
    () => getNavData(ctxtUser?.userId, ctxtUser?.isComUser),
    {
      enabled: isNotEmpty(ctxtUser?.userId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });
  const txtFieldSx = { width: "100%", height: 30, borderRadius: 1 }
  const [attchs, setAttchs] = useState([]);
  const currProj = JSON.parse(localStorage.getItem('currProj')|| "{}");

  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (!userData)
      navigate("/", { replace: true })
    else if (!userData?.currProj) {
      notify("error", "The user is not currently working on any project!")
      navigate("/", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData])

  function handleFileRemove(index) {
    const updatedImages = attchs.filter((_, i) => i !== index);
    setAttchs(updatedImages);
  };

  function handleOnFileUpload(uploadedFiles) {
    setAttchs(prev => [...prev, ...uploadedFiles])
  }


  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const cProj = (ctxtUser?.userType === constants.requestor || ctxtUser?.userType === constants.approver) ? userData?.currProj[0] : currProj;
      const payload = {
        deptId: cProj?.deptId,
        projIdStrg: cProj?.projIdStrg,
        mailSubject: inputObject.mailSubject,
        mailContent: inputObject.mailContent,
        attachArr: attchs.map((i) => ({ attachFile: i.fileKey, fileName: i.fileName }))
      }
      const { message } = await createNewProdReqServ(payload);
      notify("success", message);
      navigate(`${route.cNewProdreqlist}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};
    if (!values.mailSubject)
      errors.mailSubject = "Subject is required!";
    if (!values.mailContent)
      errors.mailContent = "Description is required!";

    return errors;
  };




  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (
    <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%", position: "relative" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton />
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create New Product Request</Typography>
        <Box />
      </Stack>
      <BgBoxOld height={"93%"} py={1}>
        <Stack gap={1} mt={1}>
          <LabelTxtFieldInfo name="mailSubject" errMsg={formErrors.mailSubject} title="Subject *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="mailContent" errMsg={formErrors.mailContent} title="Description *" {...txtFieldSx}
            rows={14} multiline={true} height={250} />
          <AttachFileUpload title={"Attachments"} height={100} width={"100%"} filesArr={attchs} onUpload={handleOnFileUpload} onRemove={handleFileRemove} />
        </Stack>

      </BgBoxOld>

      <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
        <Button variant="contained" type='submit' sx={{
          borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 14, color: "rgba(7, 42, 200, 1)"
        }} >
          CREATE REQUEST
        </Button>
      </Box>
    </form>
  );
}

export default CreateNewProdReqPage;